import ngImageLoad from 'ng-image-load';
import { displayCoverPicComponent } from './display-cover-pic.component';

export const displayCoverPic = angular
    .module('common.components.displayCoverPic', [
        ngImageLoad
    ])
    .component('displayCoverPic', displayCoverPicComponent)
    .config((NgImageLoadServiceProvider) => {
        'ngInject';

        NgImageLoadServiceProvider.preloadImage({
            key: 'coverPic', 
            url: '/./images/placeholder.png'
        });
    })
    .name;


// WEBPACK FOOTER //
// ./src/app/common/components/display-cover-pic/display-cover-pic.module.js